<template>
  <div
    class="pos_container_panel"
    style="padding-left: 2rem; width: 90%; background-color: white"
  >
    <Loading :loading="submitLoading" />
    <el-form
      :inline="true"
      :model="searchForm"
      style="margin-left: 6rem; padding-top: 2rem"
    >
      <el-row>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <el-form-item label="产品类型" class="form-label-field">
            <el-select
              v-model="searchForm.types"
              clearable
              :label-width="formLabelWidth"
            >
              <el-option
                v-for="item in proType"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <el-form-item label="客户名称" class="form-label-field">
            <el-input
              v-model="searchForm.customerName"
              autocomplete="off"
              :label-width="formLabelWidth"
              @click="showClientNamePop"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <el-form-item label="订单号" class="form-label-field">
            <el-input
              v-model="searchForm.orderNumber"
              autocomplete="off"
              :label-width="formLabelWidth"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <el-form-item label="开票状态" class="form-label-field">
            <el-select
              v-model="searchForm.applyStatus"
              clearable
              :label-width="formLabelWidth"
            >
              <el-option
                v-for="item in Status"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16">
          <el-form-item label="申请日期">
            <el-date-picker
              type="date"
              v-model="searchForm.startDate"
              placeholder="yyyy/mm/dd"
            ></el-date-picker>
            <span style="padding: 0 5px;">至</span>
            <el-date-picker
              type="date"
              v-model="searchForm.endDate"
              placeholder="yyyy/mm/dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
          <el-form-item label="开票主体" class="form-label-field">
            <el-select
              v-model="searchForm.invoicingTitle"
              clearable
              :label-width="formLabelWidth"
            >
              <el-option
                v-for="item in invoicingTitleOption"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="end">
        <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
          <div class="grid-content bg-purple-left marquee">
            <div class="marquee-content">
              <label style="font-size: 1.3rem; color: red">{{
                InvoiceErrorMessage
              }}</label>
            </div>
          </div>
        </el-col>
        <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="grid-content bg-purple-light">
            <el-button type="warning" class="harpIDbtn" @click="Search()"
              >搜索</el-button
            >
            <el-button type="warning" class="harpIDbtn" @click="clickExport()"
              >导出</el-button
            >
          </div>
        </el-col>
      </el-row>
    </el-form>
    <el-table :data="tableData" style="margin-top: 30px">
      <el-table-column
        prop="bookingCode"
        label="订单号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="customerName"
        label="客户名称"
        align="center"
      ></el-table-column>
      <el-table-column prop="invoiceStatus" label="开票状态" align="center">
        <template #default="{ row }">
          <span>{{ formatInvoiceStatuse(row.invoiceStatus) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="orderAmount"
        label="可开金额"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="invoiceAmount"
        label="实开金额"
        align="center"
      ></el-table-column>
      <el-table-column prop="invoiceTypes" label="开票主体" align="center">
        <template #default="{ row }">
          <span>{{ formatInvoiceTypes(row.invoiceTypes) }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="drawer" label="开票人" align="center"></el-table-column> -->
      <el-table-column prop="invoiceDate" label="开票日期" align="center">
        <template #default="{ row }">
          <span>{{ formatDate(row.invoiceDate) }}</span>
        </template></el-table-column
      >
      <el-table-column
        prop="invoiceNo"
        label="发票号码"
        align="center"
      ></el-table-column>
      <el-table-column prop="invoiceHeaderType" label="发票类型" align="center">
        <template #default="{ row }">
          <span>{{ formatInvoiceHeaderType(row.invoiceHeaderType) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="headerName"
        label="购方企业名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="contectEmail"
        label="购方邮箱"
        align="center"
      ></el-table-column>
      <!-- <el-table-column prop="goodsName" label="开票项目" align="center"></el-table-column> -->
      <el-table-column
        prop="invoiceTotalPrice"
        label="发票金额(不含税）"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="invoiceTotalTax"
        label="开票税额"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="提交时间"
        align="center"
        width="110px"
      >
        <template #default="{ row }">
          <span>{{ formatDate(row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="发票PDF链接"
        align="center"
        width="110px"
      >
        <template #default="{ row }">
          <div v-if="row.pdfUrl">
            <a :href="processPDFUrl(row)">发票链接</a>
          </div>
          <div v-else></div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('ORDERLIST.Operation')"
        fixed="right"
        width="120"
        align="center"
      >
        <template #default="scope">
          <el-button
            v-if="scope.row.invoiceStatus == 0"
            @click="updateStatusClick(scope.row)"
            type="text"
            size="small"
            >修改状态</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-bottom: 1rem">
      <el-pagination
        class="paginationsty"
        background
        @current-change="handleCurrentChange"
        v-model:current-page="currentPage"
        :page-size="15"
        layout="total, prev, pager, next"
        :total="searchForm.total"
      />
    </div>
    <ClientList
      :customerDialogVisible="clientListFlag"
      @setCustomerFlag="setCustomerFlag"
      @customerInfo="selectClient"
    ></ClientList>
    <el-dialog
      v-model="updateInvoiceStatusDialog"
      width="30%"
      :show-close="false"
    >
      <el-divider class="title-headerDivider"></el-divider>
      <el-form :inline="true">
        <el-row :gutter="10" class="content_size">
          <el-col :span="10">
            <el-form-item
              label="开票状态"
              class="form-label-field"
            ></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item>
              <el-select v-model="updateRowInvoiceStatus" filterable>
                <el-option
                  v-for="item in UpdateStatus"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="warning" class="harpIDbtn" @click="saveInvoiceStatus">{{ $t("INVOICINGBUTTON.SAVE") }}</el-button>
          <el-button @click="updateInvoiceStatusDialog = false" class="harpIDbtn">{{ $t("INVOICINGBUTTON.CANCEL") }}</el-button>
        </div>
      </template>
    </el-dialog>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
  </div>
</template>
    
  <script>
import ClientList from "@/components/ClientList.vue";
import {
  searchInvoiceList,
  preDownloadInvocieExcel,
  downloadInvocieExcel,
  updateInvoiceRecordStatus,
  getInvoiceErrorMessage,
} from "@/api/bookingData";
import Loading from "@/components/Loading.vue";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
import { formatDateTime, getFileName } from "@/utils/utils.js";
export default {
  name: "InvoicingList",
  components: {
    Loading,
    ClientList,
    ConfirmBoxs,
  },
  data() {
    return {
      submitLoading: false,
      currentPage: 1,
      formLabelWidth: "150px",
      tableData: [],
      searchForm: {
        types: "",
        customerId: "",
        customerName: "",
        orderNumber: "",
        applyStatus: "",
        startDate: "",
        endDate: "",
        total: 0,
        invoicingTitle: "",
      },
      proType: [
        { value: "全部", key: "" },
        { value: "酒店", key: "JD" },
        { value: "火车", key: "HC" },
        { value: "机票", key: "JP" },
      ],
      Status: [
        { value: "全部", key: "" },
        { key: 0, value: "未开票" },
        { key: 1, value: "已开票" },
        { key: 2, value: "开票中" },
        { key: 3, value: "已开票-线下" },
      ],
      UpdateStatus: [
        { key: 0, value: "未开票" },
        { key: 3, value: "已开票-线下" },
      ],
      invoicingTitleOption: [
        { value: "全部", key: "" },
        { key: 1, value: "中航嘉信商务旅行管理有限公司" },
        { key: 2, value: "中航嘉信商务旅行管理有限公司上海分公司" },
      ],
      clientListFlag: false,
      updateInvoiceStatusDialog: false,
      updateRowInvoiceStatus: 0,
      updateRowOrderNumber: "",
      confirmFlag: false,
      confirmMsg: "",
      InvoiceErrorMessage: "", //错误消息提示
    };
  },
  computed: {
    formatInvoiceStatuse() {
      var statusName = "";
      return (status) => {
        var result = this.Status.find(function (obj) {
          return obj.key === status;
        });
        if (result != undefined) {
          statusName = result.value;
        }
        return statusName;
      };
    },
    formatDate() {
      return function (value) {
        if (value == undefined || value == null) {
          return null;
        }
        return formatDateTime(value, "YYYY-MM-DD");
      };
    },
  },
  mounted() {
    this.searchForm.startDate = new Date(
      new Date().setDate(new Date().getDate() - 14)
    ).toLocaleDateString();
    this.searchForm.endDate = new Date().toLocaleDateString();
    this.Search();
    this.getInvoiceErrorMessage();
  },
  methods: {
    formatInvoiceTypes(type) {
      return type == 1
        ? this.$t("INVOICINGINFO.INVOICINGCOMPANY")
        : this.$t("INVOICINGINFO.INVOICINGCOMPANY1");
    },
    formatInvoiceHeaderType(type) {
      switch (type) {
        case 1:
          return this.$t("INVOICINGHEADERTYPE.CORPORATION");
        case 2:
          return this.$t("INVOICINGHEADERTYPE.PERSONS");
        case 3:
          return this.$t("INVOICINGHEADERTYPE.NOCORPORATION");
        default:
          return '';
      }
    },
    handleCurrentChange(val) {
      this.Search(val);
    },
    //搜索button
    async Search(int) {
      this.submitLoading = true;
      let searchparams = {
        pageNum: int ? int : 1,
        pageSize: 15,
        types: this.searchForm.types,
        customerId: this.searchForm.customerId,
        customerName: this.searchForm.customerName,
        orderNumber: this.searchForm.orderNumber,
        applyStatus: this.searchForm.applyStatus,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        invoicingTitle: this.searchForm.invoicingTitle,
      };
      await searchInvoiceList(searchparams)
        .then((res) => {
          this.submitLoading = false;
          this.tableData = res.data.list;
          this.searchForm.total = res.data.pagination.total;
        })
        .catch(function (error) {
          this.submitLoading = false;
          console.log("请求失败", error.objError);
        });
    },
    //搜索点击客户名称弹出选择客户
    showClientNamePop() {
      this.isPosAdd = false;
      this.clientListFlag = true;
    },
    //选择客户
    selectClient(item) {
      this.searchForm.customerName = item.customerName;
      this.searchForm.customerId = item.customerCode;
    },
    setCustomerFlag(value) {
      this.clientListFlag = value;
    },
    //excel 导出
    async clickExport() {
      //请求接口
      let downParam = {
        pageNum: 1,
        pageSize: 15,
        types: this.searchForm.types,
        customerId: this.searchForm.customerId,
        customerName: this.searchForm.customerName,
        orderNumber: this.searchForm.orderNumber,
        applyStatus: this.searchForm.applyStatus,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
      };
      await preDownloadInvocieExcel(downParam)
        .then((preRes) => {
          if (preRes.code == 200) {
            if (preRes.data.error.code == 0) {
              //开始下载
              this.$message(this.$t("MESSAGE.DOWNLOADSTART"));
              downloadInvocieExcel(downParam)
                .then((res) => {
                  // 执行下载
                  const downloadLink = document.createElement("a");
                  // 设置下载文件名
                  const fileName = getFileName();
                  // .csv 文件后缀
                  downloadLink.download = fileName + ".xls"; // 文件名称
                  downloadLink.style.display = "none";
                  //csv文件的type  text/csv    xls:application/vnd.ms-excel
                  const blob = new Blob([res], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  }); //字节转成 Blob
                  downloadLink.href = URL.createObjectURL(blob);
                  document.body.appendChild(downloadLink);
                  downloadLink.click();
                  document.body.removeChild(downloadLink);
                })
                .catch((error) => {
                  console.log("导出Excel", error);
                });
            } else {
              this.confirmFlag = true;
              this.confirmMsg =
                this.$t("ERRORMESSAGE." + preRes.data.error.code) ===
                "ERRORMESSAGE." + preRes.data.error.code
                  ? this.$t("ERRORMESSAGE.NOTFOUND")
                  : this.$t("ERRORMESSAGE." + preRes.data.error.code);
              console.log(
                "导出Excel预下载执行失败, code:" + preRes.code,
                preRes.message
              );
            }
          } else {
            this.confirmFlag = true;
            this.confirmMsg = this.$t("ERRORMESSAGE.500");
            console.log("导出Excel预下载执行失败");
          }
        })
        .catch((error) => {
          this.orderloading = false;
          this.confirmFlag = true;
          this.confirmMsg = this.$t("ERRORMESSAGE." + error.mesCode);
          console.log("导出Excel预下载执行异常", error.objError);
        });
    },
    updateStatusClick(row) {
      this.updateRowInvoiceStatus = row.invoiceStatus;
      this.updateRowOrderNumber = row.bookingCode;
      this.updateInvoiceStatusDialog = true;
    },
    saveInvoiceStatus() {
      let param = {
        params: {
          orderNumber: this.updateRowOrderNumber,
          invoiceStatus: this.updateRowInvoiceStatus,
        },
      };
      let that = this;
      updateInvoiceRecordStatus(param).then((res) => {
        if (res.code === 200) {
          this.confirmFlag = true;
          this.confirmMsg = this.$t("SERVICECHARGEINFO.SERVICECHARGESUCCESS");
          this.updateInvoiceStatusDialog = false;
          this.Search();
        } else {
          this.confirmFlag = true;
          this.confirmMsg = this.$t("SERVICECHARGEINFO.SERVICECHARGEERROR");
          this.updateInvoiceStatusDialog = false;
        }
      });
    },
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    processPDFUrl(row) {
      console.log("row.pdfUrl", row.pdfUrl);
      if (row.pdfUrl.startsWith("http://")) {
        row.pdfUrl = "https://" + row.pdfUrl.substring(7);
      }
      return row.pdfUrl;
    },
    getInvoiceErrorMessage() {
      let param = {};
      let that = this;
      getInvoiceErrorMessage(param).then((res) => {
        if (res.code === 200) {
          if (
            res.message != undefined &&
            res.message != "" &&
            res.message != null
          ) {
            that.InvoiceErrorMessage = "开票错误提示:" + res.message;
          }
        }
      });
    },
  },
};
</script>
   <style scoped>
.paginationsty {
  float: right;
  margin: 1rem 0;
}

.pos_container_panel {
  padding: 0 16rem 4rem;
}

.harpIDbtn {
  width: 10rem;
  height: 3rem;
  padding: 0 !important;
  font-size: 1rem !important;
}
::v-deep .el-input__inner {
  height: 27px;
}
::v-deep .el-dialog__body {
  padding: 0;
}
.title-headerDivider {
  margin-bottom: 1rem;
  margin-top: 1rem;
  height: 2px;
  background-color: #fc6640;
}
.content_size {
  margin-left: 6rem !important;
  margin-right: 5rem !important;
}

.marquee {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
}

.marquee-content {
  display: inline-block;
  padding-left: 50%; /* 使内容从右侧开始 */
  animation: marquee 10s linear infinite; /* 动画效果 */
}
@keyframes marquee {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-100%, 0); /* 向左移动 */
  }
}
.form-label-field {
  height: 3.7rem;
  border-radius: 0;
  width: 18vw;
  /* margin-top: 1rem; */
}
</style>
    